/* eslint-disable */
import PropTypes from 'prop-types';
import { forwardRef, useContext } from 'react';

import Box from '@mui/material/Box';

import { AuthContext } from '../../context/AuthContext';
import { Typography } from '@mui/material';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }:any, ref) => {
  const { user } = useContext(AuthContext);

  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >
      {/* <Typography variant='h1' sx={{fontSize:'1.7em !important',color:"blue"}}>  Keshav Infotech </Typography> */}
     {/* <img style={{width:'50px',}} src={"/assets/logo.png"} alt="" /> */}
    </Box>
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <a  href={user?'/chat':'/'} style={{ display: 'contents' }}>
      {logo}
    </a>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
